import * as ActionTypes from './ActionTypes';

export const HindiText = (state = {
    isLoading: true,
    errMess: null,
    hindiText: null
    },action) => {
        switch(action.type){
            case ActionTypes.DOWNLOAD_TEXT_FILE:
                // console.log("Downloading Text File\n\n",action.payload)
                return {isLoading:false,errMess:null,hindiText:action.payload}
            default:
                // console.log("In Default")
                return state;
        }
    }